export default "__VITE_ASSET__7971c440__"